import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@servicesv2';

@Injectable()
export class ContratosServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Contratos', http);
  }

  getSequenciaNumero() {
    return this.getAsPromise<number>('GetSequenciaNumero');
  }

  getContratoDuplicado(clienteId: number, contratoId: number){
    return this.getAsPromise<boolean>(`GetContratoDuplicado/${clienteId}/${contratoId}`);
  }

}